import {ActionType, createAction} from 'typesafe-actions';
import {RouterNavigateOptions} from '@remix-run/router/router';

export const changeCurrentRoute = createAction(
    'CHANGE_CURRENT_ROUTE',
    (action) =>
        (route: string, options: RouterNavigateOptions = {}) =>
            action({route, options}),
);

export const layoutComponentRequestedLogoutCurrentUser = createAction(
    'LAYOUT_COMPONENT_REQUESTED_LOGOUT_CURRENT_USER',
    (action) => () => action({}),
);

export type LayoutActionTypes =
    | ActionType<typeof changeCurrentRoute>
    | ActionType<typeof layoutComponentRequestedLogoutCurrentUser>;
